import { Box } from '@zoopla-eng/zds-components/box';
import { ButtonLink } from '@zoopla-eng/zds-components/button';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';
import { fontGroups } from '@zoopla-eng/zds-components/themes';
import { CmsArticleCard } from '@zoopla/cms/article-card';
import { Carousel } from '@zoopla/cms/carousel';
import { triggerTracking } from '@zoopla/tracking';
import { articleCollectionDescriptionStyle } from './CmsArticleCollection.styles.css';
import { CmsArticleCollectionProps } from './CmsArticleCollection.type';

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}

const articleTracking = (
    articleSlug: string,
    articleCategory: string,
    index: number
) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'content_module',
        eventAction: 'article_clickthrough',
        eventLabel: `/discover/${articleCategory}/${articleSlug}/,${index + 1}`
    });
};

export function CmsArticleCollection({
    articleCollectionData,
    carouselConfig,
    horizontalCardLayout,
    seeMoreLink,
    trackingFunction
}: CmsArticleCollectionProps) {
    let horizontalCardCondition =
        (articleCollectionData?.articles?.total || 0) <= 2;

    if (horizontalCardLayout !== undefined) {
        horizontalCardCondition = horizontalCardLayout;
    }

    return (
        <div>
            {!articleCollectionData?.hideTitleAndDescription && (
                <Box display="flex" justifyContent="flex-start">
                    <Box>
                        <PageSubtitleShort>
                            {articleCollectionData?.title}
                        </PageSubtitleShort>
                        {articleCollectionData?.description ? (
                            <p
                                className={`${articleCollectionDescriptionStyle} ${fontGroups.whisk}`}
                            >
                                {articleCollectionData.description}
                            </p>
                        ) : null}
                    </Box>
                    {seeMoreLink && (
                        <Box
                            display="none"
                            pt="S100"
                            bpS200={{ display: 'block' }}
                        >
                            <ButtonLink
                                href={seeMoreLink.buttonUrl}
                                category={seeMoreLink.category}
                            >
                                {seeMoreLink.buttonLabel}
                            </ButtonLink>
                        </Box>
                    )}
                </Box>
            )}
            <Carousel breakpoints={carouselConfig?.breakpoints}>
                {articleCollectionData?.articles?.items
                    .filter(notEmpty)
                    .map((article, articleKey) => (
                        <CmsArticleCard
                            article={article}
                            index={articleKey}
                            key={articleKey}
                            horizontalLayout={horizontalCardCondition}
                            heroArticle={
                                articleCollectionData.articles?.total === 1
                            }
                            trackingFunction={() =>
                                trackingFunction
                                    ? trackingFunction(article, articleKey)
                                    : articleTracking(
                                          article?.slug ?? '',
                                          article?.category?.slug ?? '',
                                          articleKey
                                      )
                            }
                            headingLevel="h3"
                        />
                    ))}
            </Carousel>
        </div>
    );
}

export default CmsArticleCollection;
